export default defineNuxtRouteMiddleware(async (to, _from) => {
  const trust = useDeviceTrust()
  const { token, expires } = useDirectusToken()
  const { fetchUser, setUser } = useDirectusAuth()
  const userStore = useUserStore()
  const { setUserLocal, logout } = userStore
  const user = useDirectusUser()

  const renewOrThrow = async () => {
    if (!(await trust.renewSession())) {
      throw new Error('SESSION_EXPIRED')
    }
  }

  const syncUserFromDirectus = async () => {
    const fetchedUser = await fetchUser()

    if (!fetchedUser.value) {
      throw new Error('Utilisateur introuvable après authentification.')
    }

    setUser(fetchedUser.value)

    const policiesResult = await $fetch('/api/account/policies').catch(() => ({ policyIds: [] as string[], tfa: null }))

    setUserLocal({
      ...fetchedUser.value,
      policies: policiesResult.policyIds,
    })
    userStore.setTfaStatus(policiesResult.tfa)
  }

  // Tunnel de configuration : tant que la 2FA obligatoire n'est pas configurée, seule cette page est accessible
  const enforceTfaSetup = () => {
    if (userStore.needsTfaSetup && to.path !== TFA_SETUP_PATH) {
      return navigateTo(TFA_SETUP_PATH)
    }
  }

  // Hors ligne : on garde la session locale (données en cache) sans revalider ni déconnecter.
  if (import.meta.client && !navigator.onLine && userStore.isLoggedIn && token.value) {
    return enforceTfaSetup()
  }

  if (!user.value) {
    try {
      // Rechargement de page : on restaure l'utilisateur avec le jeton encore valide, sans renouvellement
      if (token.value && (expires.value ?? 0) > Date.now()) {
        try {
          await syncUserFromDirectus()
          return enforceTfaSetup()
        }
        catch (error) {
          console.warn('Jeton existant refusé, tentative de renouvellement...', error)
        }
      }

      await renewOrThrow()
      await syncUserFromDirectus()
      return enforceTfaSetup()
    }
    catch (error) {
      console.error('Impossible de restaurer la session:', error)
      trust.endSession()
      logout()
      return navigateTo('/volontaires/connexion')
    }
  }

  try {
    await syncUserFromDirectus()
    return enforceTfaSetup()
  }
  catch (error) {
    console.warn('Impossible de revalider la session, tentative de refresh...', error)
  }

  try {
    await renewOrThrow()
    await syncUserFromDirectus()
    return enforceTfaSetup()
  }
  catch (error) {
    console.error('Impossible de rafraîchir la session:', error)
    trust.endSession()
    logout()
    return navigateTo('/volontaires/connexion')
  }
})
